import { Badge, Button, Descriptions } from "antd";
import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { alertify, generate_query_set, handleApiExceptions } from "../../../../app_methods";
import { API_REQUESTS_STATUS_TYPES, VENDOR_APPROVAL_STATUS } from "../../../../constants";
import { EaseDrawer } from "../../../../libs/EaseDrawer";
import { EaseTable } from "../../../../libs/EaseTable";
import { updateCurrentUserAction } from "../../../../redux/actions";
import { Text4 } from "../../../../styles";
import { ContentCard } from "../../../Common";
import { PermissionHoc } from "../../../HOC";
import { approvalTableFilterNodes, getApprovalsColumns } from "./constants";
import { connect } from "react-redux";
import { Approvals } from "../../../../models/vendorPayouts/approvals";
import { ApprovalDetailsDrawer } from "./details";

const ApprovalsList = (props) => {
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
    showSizeChanger: true,
    pageSizeOptions: ["10", "25", "50", "100"],
    showTotal: (total) => `Total ${total} Records`,
  });
  const [filters, setFilters] = useState({});
  const [showStatusInfoDrawer, setShowStatusInfoDrawer] = useState(false);
  const [showDetailsDrawer, setShowDetailsDrawer] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState({});
  const [approvalsList, setApprovalsList] = useState([]);

  const PermissableButton = PermissionHoc(Button, "", { is_component: true, fallbackComponent: null, });

  const fetchList = async (_pagination = pagination, _filters = filters) => {
    setIsTableLoading(true);
    const response = await Approvals.approvals_list({
      ...{ pageSize: _pagination.pageSize, current: _pagination.current },
      ..._filters,
    });
    if (!response.success) {
      setIsTableLoading(false);
      handleApiExceptions(response);
      return;
    }

    let queryset = generate_query_set(Approvals, response.data.results);
    setApprovalsList(queryset);
    setPagination({ ...pagination, total: response.data.count });
    setIsTableLoading(false);
    setSelectedVendor(new Approvals(response.data.results.find((vendor) => vendor.id == selectedVendor.id)));

  };

  useEffect(() => {
    props.onChildMount();
    fetchList({ ...pagination }, { ...filters });
  }, []);

  const approval_action = async (values) => {

    const response = await Approvals.approval_update(values);
    if (!response.success) {

      handleApiExceptions(response);
      return;
    }

    fetchList(pagination, filters);

  };


  const toggleDetailsDrawer = (obj = {}) => {
    setSelectedVendor(obj);
    setShowDetailsDrawer(!showDetailsDrawer);
  };

  const toggleStatusInfoDrawer = () => {
    setShowStatusInfoDrawer(!showStatusInfoDrawer);
  };

  const tableColumns = getApprovalsColumns({
    toggleDetailsDrawer,
    toggleStatusInfoDrawer,
    approval_action
  });

  let filterNodes = approvalTableFilterNodes();

  const handleTableChange = (tableInfo) => {
    if (tableInfo.trigger == "columns") return;
    let _pagination = tableInfo.pagination;
    if (tableInfo.trigger == "filters") _pagination.current = 1;
    setPagination(_pagination);
    setFilters(tableInfo.filters);
    fetchList(_pagination, tableInfo.filters);
  };

  return (
    <div>
      <ContentCard className="p-3">
        <div className="w-100 d-flex justify-content-end">
        </div>
        <EaseTable
          rowKey="uuid"
          loading={isTableLoading}
          data={approvalsList}
          columns={tableColumns}
          fixedSelectable={!isMobile}
          handleTableChange={handleTableChange}
          pagination={pagination}
          totalRecords={pagination.total}
          filterNodes={filterNodes}
        />

      </ContentCard>

      <EaseDrawer
        visible={showStatusInfoDrawer}
        onClose={toggleStatusInfoDrawer}
        hideFooter
        title="Approval Statuses"
        width={500}
      >
        <Descriptions
          bordered
          className="mt-3"
          size="small"
          layout="horizontal"
          column={1}
        >
          {Object.keys(VENDOR_APPROVAL_STATUS).map((key, index) => {
            return (
              <Descriptions.Item
                label={
                  <Badge
                    color={VENDOR_APPROVAL_STATUS[key].color}
                    text={
                      <Text4>{VENDOR_APPROVAL_STATUS[key].label}</Text4>
                    }
                  />
                }
              >
                {VENDOR_APPROVAL_STATUS[key].description}
              </Descriptions.Item>
            );
          })}
        </Descriptions>
      </EaseDrawer>

      <ApprovalDetailsDrawer
        visible={showDetailsDrawer}
        onClose={toggleDetailsDrawer}
        // vendor={selectedVendor}
        fetchList={fetchList}
        merchant={props.current_user}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  current_user: state.userReducer.current_user,
});

const mapDispatchToProps = (dispatch) => ({
  updateCurrentUser: (user) => dispatch(updateCurrentUserAction(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PermissionHoc(ApprovalsList, "VENDOR_READ"))
